import React from "react"
import Button from "components/Button"
import ModalButtons from "components/ModalButtons"
import LabelValue from "components/LabelValue"
import { dipRequest } from "data/dip/api"
import withModal from "hoc/withModal"
import { toastSuccess, toastError } from "data/toasts/rx"
import * as R from "ramda"

const CheckUpdateTaMSModal = ({ close, report, taxAccount, refetch }) => {
  const handleSubmit = () => {
    dipRequest.updateStatusMS(report.id).subscribe({
      next: () => {
        toastSuccess("Request to update the report was sent. It will be processed in a few minutes.")
        close()
        refetch()
      },
      error: (error) => {
        const message = error.text || "Failed to update the report."
        toastError(message)
      },
    })
  }

  return (
    <>
      <LabelValue mb={20} label="Filing entity name" value={report.entityName} />
      <LabelValue mb={20} label="Filing entity ID" value={taxAccount.elster ?? taxAccount.bop ?? report.entityId} />
      <LabelValue mb={20} label="Account type" value={taxAccount.elster ? "Elster" : taxAccount.bop ? "BOP" : "N/A"} />
      <ModalButtons>
        <Button secondary type="button" onClick={close} text="Cancel" />
        <Button type="submit" text="Check updates from TA" onClick={handleSubmit} />
      </ModalButtons>
    </>
  )
}

export default R.compose(
  withModal(R.always("Check udpates from TA")),
)(CheckUpdateTaMSModal)
